<template>
	<div class="rule">
		<ul class="step">
    		<li class="step-arrow"></li>
        	<li class="step-text">填写订单</li>
        	<li class="step-arrow"></li>
        	<li class="step-text ">订单支付</li>
        	<li class="step-arrow "></li>
        	<li class="step-text">订单完成</li>
    	</ul>
    	<div class="information">
    		<div class="pay">
    			<div class="pay-img">
    				<img src="./../../assets/img/img19.png" alt="" />
    			</div>
                <div class="pay-content" v-if="order.PackageType==1">
                    <p class="one">订单号: <span>{{OrderNO}}</span></p>
                    <p class="two" v-if="order.PayStatu == 0">
                        未支付
                        <span class="book-unpay" v-if="order.NeedPay" @click="topay">去支付</span>
                    </p>
                    <p class="two" v-else>支付成功</p>
                    <p class="three-a" v-if="order.Status == 10&&order.NeedPay">待付款</p>
                    <p class="three-a" v-if="order.Status == 10&&!order.NeedPay">待确认</p>
                    <p class="three-a" v-if="order.Status == 11&&order.NeedPay">待付款</p>
                    <p class="three-a" v-if="order.Status == 11&&!order.NeedPay">待确认</p>
                    <p class="three-a" v-if="order.Status == 20">已确认</p>
                    <p class="three-a" v-if="order.Status == 40">已使用</p>
                    <p class="three-a" v-if="order.Status == 50">已取消</p>
                    <div class="btn" @click="getOrderData()"><i class="iconfont icon-reload"> </i> 刷新</div>
                </div>

                <div class="pay-content" v-else>
                    <p class="one">订单号: <span>{{OrderNO}}</span></p>
                    <p class="two" v-if="order.PayStatu == 0">
                        未支付
                        <span class="book-unpay" v-if="order.NeedPay" @click="topay">去支付</span>
                    </p>
                    <p class="two" v-else>支付成功</p>
                    <p class="three-a" v-if="order.Status == 10&&order.NeedPay">待付款</p>
                    <p class="three-a" v-if="order.Status == 10&&!order.NeedPay">待预约</p>
                    <p class="three-a" v-if="order.Status == 11">预约中</p>
                    <p class="three-a" v-if="order.Status == 12">部分预约</p>
                    <p class="three-a" v-if="order.Status == 20">已预约</p>
                    <p class="three-a" v-if="order.Status == 40">已使用</p>
                    <p class="three-a" v-if="order.Status == 50">已取消</p>
                    <div class="btn" @click="getOrderData()"><i class="iconfont icon-reload"> </i> 刷新</div>
                </div>

    		</div>
    	</div>
    	<div class="information-a">

    		<table>
    			<thead>
    				<tr>
    					<td width="32%">产品名称</br>产品类型</td>
    					<td width="13%">{{order.PackageType==1?'出发时间':'有效期至'}}</td>
    					<td width="15%">入住人名称<br/>联系电话</td>
    					<td width="8%">份数</td>
    					<td width="14%">订单状态</td>
    					<td width="10%">总金额</td>
    					<td width="9%">详情</td>
    				</tr>
    			</thead>
    			<tbody>
    				<tr>
    					<td>
                            {{order.ProductName}}</br>
                            {{order.SKUName}}
                        </td>
    					<td>
                            <span v-if="order.PackageType==1">
                                {{order.CheckIn|dateToYMDline}}
                            </span>
                            <span v-else>
                                {{order.EndActiveDate|dateToYMDline}}
                            </span>
                        </td>
    					<td>
                            <div v-for="guest in order.Guests">{{guest.CnName}}</div>
                            <div>{{order.ReceiverPhone}}</div>
                        </td>
    					<td>{{order.Count}}</td>
                        <td v-if="order.PackageType==1">
                            <span v-if="order.Status == 10&&order.NeedPay" class="colorRed">等待付款</span>
                            <span v-if="order.Status == 10&&!order.NeedPay" class="colorRed">等待确认</span>
                            <span v-if="order.Status == 11&&order.NeedPay" class="colorRed">等待付款</span>
                            <span v-if="order.Status == 11&&!order.NeedPay" class="colorRed">等待确认</span>
                            <span v-if="order.Status == 20">已确认</span>
                            <span v-if="order.Status == 40">已使用</span>
                            <span v-if="order.Status == 50">已取消</span>
                        </td>
    					<td v-if="order.PackageType==2">
                            <span v-if="order.Status == 10&&order.NeedPay" class="colorRed">等待付款</span>
                            <span v-if="order.Status == 10&&!order.NeedPay" class="colorRed">等待预约</span>
                            <span v-if="order.Status == 11">预约中</span>
                            <span v-if="order.Status == 12">部分预约</span>
                            <span v-if="order.Status == 20">已预约</span>
                            <span v-if="order.Status == 40">已使用</span>
                            <span v-if="order.Status == 50">已取消</span>
                        </td>
    					<td>{{Currency}} {{order.TotalAmount}}</td>
    					<td><span class="link-a" @click="toOrder" >详情</span></td>
    				</tr>
    			</tbody>
    		</table>
    	</div>
    	<div class="information-b">
    		<div class="button">
    			<div class="btn" @click="toHome">返回首页</div>
    			<div class="return" @click="toOrder">订单管理</div>
    		</div>
    	</div>
	</div>
</template>
<script>
	export default{
		name:'book-complete',
		data(){
			return{
                Currency: this.dao.get('userInfo').Currency,
				userInfo:this.dao.get('userInfo'),
                bookInfo:this.dao.get('packageBookInfo'),
                OrderNO:this.$route.query.OrderNO,
                order:'',
			}
		},
		methods:{
            getOrderData(){
                var that = this;
                var param={
                    OrderNO:that.$route.query.OrderNO
                }
                that.getRequest({
                    url: that.Api.getPackageOrderDetails,
                    params:param
                }).then(res => {
                    if (res && res.IsSuccess) {
                        that.order = res.Result
                        that.$nextTick(() => {
                            if(localStorage.getItem('lang')=='t'){
                                that.$zh_tran(localStorage.getItem('lang'))
                            }         
                        })
                    } else {
                        that.error({title:'提示',content:'获取订单状态出错，请刷新页面重试'});
                    }
                });
            },
            topay(){
                this.$router.push('/packageBookComfirm?OrderNO='+this.OrderNO)
            },
			toHome(){
				this.$router.push('/');
			},
			toOrder(){
                  window.open('#/packageOrderDetails/'+this.OrderNO, '_blank');
				// this.$router.push('/orderDetails/'+this.OrderNO);
			}

		},
        mounted(){
            var that = this
             document.title='预定完成---订房易';
             that.getOrderData();
             that.$nextTick(() => {
                if(localStorage.getItem('lang')=='t'){
                    that.$zh_tran(localStorage.getItem('lang'))
                }       
            })
        }

	}
</script>



// WEBPACK FOOTER //
// src/components/package/bookComplete.vue